import {
  getUsersByUserId,
  patchAddRoleToUser,
  patchChangeUserId,
  patchChangeUserType,
  patchRemoveRoleFromUser,
  User,
} from '@nemuru-eng/js-api-client';

import { getSelectedUserTypeAndRole } from '@/components/shared/components/UserList/components/UserTable/components/UserTableBody/components/UserActionsRowDialog/components/ChangeUser/utils/getSelectedUserTypeAndRole';
import { useDialog } from '@/components/shared/hooks/useDialog';
import { useCache } from '@/hooks/requests/useCache';
import { useRequest } from '@/hooks/requests/useRequest';
import { UserInStructure } from '@/types/UserInStructure';

interface UseChangeUserProps {
  userId: string;
  selectedDestination: UserInStructure | undefined;
  selectedUser: User;
  handleCloseDialog: () => void;
}

export const useChangeUser = ({ userId, selectedDestination, selectedUser, handleCloseDialog }: UseChangeUserProps) => {
  const { revalidate } = useCache(getUsersByUserId, { userId });
  const { request, loading } = useRequest();
  const { opened, setOpened } = useDialog();
  const onSubmit = () => {
    setOpened(true);
  };

  const onConfirmChange = async () => {
    if (!selectedDestination) return;

    const { role, type } = getSelectedUserTypeAndRole(selectedDestination);
    if (selectedUser.userType !== type) {
      await request(patchAddRoleToUser, { id: selectedUser.id, role });
      await request(patchChangeUserType, { id: selectedUser.id, userType: type });
      await request(patchRemoveRoleFromUser, { id: selectedUser.id, role: selectedUser.roles[0] });
    }
    await request(patchChangeUserId, { id: selectedUser.id, userId: selectedDestination.id });
    setOpened(false);
    handleCloseDialog();
    revalidate();
  };

  return {
    onSubmit,
    onConfirmChange,
    confirmationDialogOpened: opened,
    setConfirmationDialog: setOpened,
    loading,
  };
};
